// SkipLayout — pushes <SkipNav /> into the SidebarContext for the
// Skip Management module's route subtree. Same pattern as
// CollectionsLayout — see that file for the design rationale.

import { Outlet } from 'react-router-dom';
import { useSidebarContent } from '../../components/shell/SidebarContext';
import { SkipNav } from './components/SkipNav';

const SKIP_NAV = <SkipNav />;

export function SkipLayout() {
  useSidebarContent(SKIP_NAV);
  return <Outlet />;
}
